import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { sizes } from '../../const/sizes';
import { useTestIdAttribute } from '../../hooks/useTestIdAttribute';
import { Text } from '../Text/Text';
import { Box } from '../layout/Box';
import { TABLE_BORDER_STYLE, tableCellBackgroundMap } from './tableConst';
const StyledTableCell = styled('td', ({ $rowIndex, $columnIndex, $totalColumns, $totalRows, $textAlign = 'left', $backgroundColor, }) => {
    const isLastRow = $rowIndex === $totalRows - 1;
    const isFirstColumn = $columnIndex === 0;
    const isLastColumn = $columnIndex === $totalColumns - 1;
    const shouldHaveBorderBottomLeftRadius = isLastRow && isFirstColumn;
    const shouldHaveBorderBottomRightRadius = isLastRow && isLastColumn;
    return {
        borderRight: TABLE_BORDER_STYLE,
        borderBottom: TABLE_BORDER_STYLE,
        borderLeft: isFirstColumn ? TABLE_BORDER_STYLE : 'none',
        borderBottomLeftRadius: shouldHaveBorderBottomLeftRadius
            ? sizes.table.borderRadius
            : 'none',
        borderBottomRightRadius: shouldHaveBorderBottomRightRadius
            ? sizes.table.borderRadius
            : 'none',
        textAlign: $textAlign,
        backgroundColor: $backgroundColor,
    };
});
export const TableCell = ({ rowIndex, columnIndex, totalRows, totalColumns, testId, textAlign, colSpan, background = 'default', children, }) => {
    const testIdAttribute = useTestIdAttribute(testId);
    const backgroundColor = tableCellBackgroundMap[background];
    return (_jsx(StyledTableCell, { $rowIndex: rowIndex, $columnIndex: columnIndex, $totalRows: totalRows, $totalColumns: totalColumns, $textAlign: textAlign, $backgroundColor: backgroundColor, colSpan: colSpan, ...testIdAttribute, children: _jsx(Box, { spacingVertical: '3/4', spacingHorizontal: true, children: _jsx(Text, { variant: 'b2', as: 'div', children: children }) }) }));
};
